import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { CancelAgreementModalComponent } from "../../modals/cancel-agreement-modal/cancel-agreement-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { AssignAgreementComponent } from "../../modals/assign-agreement/assign-agreement.component";

@Component({
  selector: "fury-retention",
  templateUrl: "./retention.component.html",
  styleUrls: ["./retention.component.scss"],
})
export class RetentionComponent implements OnInit, OnDestroy {
  @Input() editorAccess: boolean;
  @Input() userId = "";
  ngUnsubscribe = new Subject<void>();
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  displayedColumns: string[] = [
    "agreementStatus",
    "assignedUser",
    "serviceAgreementNumber",
    "createdOn",
    "agent",
    "cancellationDate",
    "refund",
    "actions",
  ];
  pageIndex = 0;
  pageSize = 5;
  totalCount = 0;
  dataSource = [];
  constructor(
    private apiService: ApiService,
    public commonService: CommonService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getRetentionAgreements();
  }
  getRetentionAgreements() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.getRetentionAgreements(
          this.userId
        )}?page=${this.pageIndex + 1}&size=${this.pageSize}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.dataSource = res.body.agreements.data;
            this.totalCount = res.body?.agreements?.total;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getRetentionAgreements();
  }

  handleCancelAgreement(agreementId: string) {
    this.dialog
      .open(CancelAgreementModalComponent, {
        width: "600px",
        panelClass: "payment-info",
        data: { agreementId: agreementId, isShowSaveForLaterButton: false },
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (res) this.getRetentionAgreements();
      });
  }

  handleAssignAgreement(row: any) {
    this.dialog
      .open(AssignAgreementComponent, {
        data: { agreementId: row?.orderId, assignedUser: row?.assignedUser || null },
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (res) {
          this.getRetentionAgreements();
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
